module.exports = __webpack_public_path__ + "img/customers_icon.c9143f23.svg";